<script lang="ts" setup>
    import type { SearchItem } from 'vue-instantsearch/vue3/es';

    interface AlgoliaHierarchicalMenuListProps {
        items: SearchItem[];
        categoryTranslation: (category: string) => string;
        createURL: (value: string) => string;
        refine: (value: string) => void;
    }

    defineProps<AlgoliaHierarchicalMenuListProps>();
</script>
<template>
    <ul class="atm-algolia-hierarchical-menu-list flex flex-col">
        <!-- text-woom-black needed to override algolia styles  -->
        <li
            v-for="item in items"
            :key="item.value"
            class="flex flex-col border-b border-woom-grey-mid text-woom-black last:border-b-0">
            <a
                :class="['flex w-full flex-wrap gap-3 py-2.5', { 'font-bold': item.isRefined }]"
                :href="createURL(item.value)"
                @click.prevent="refine(item.value)">
                <span>{{ categoryTranslation(item.label) }}</span>
                <span class="text-woom-grey-taupe">({{ item.count }})</span>
            </a>
            <atm-algolia-hierarchical-menu-list
                v-if="item.data"
                :items="item.data"
                :category-translation="categoryTranslation"
                :refine="refine"
                :createURL="createURL"
                class="pl-4" />
        </li>
    </ul>
</template>
